<template>
  <aha-modal
    noMarginPadding
    width="1084px"
    :title="titleModal"
    :classesModal="{
      'report-session-modal': true
    }"
    @hide="hideModal"
    @openSession="openSession"
  >
    <div class="report-session-body w-full p-4">
      <div class="w-full bg-white">
        <!-- Table -->
        <div class="overflow-x-auto table-wrapper">
          <table class="min-w-full">
            <thead>
              <tr class="background-table">
                <th class="py-3 px-4 font-semibold text-left">
                  {{ $i18nPresenter.t('Session') }}
                </th>
                <th class="py-3 px-4 font-semibold text-left">
                  {{ $i18nPresenter.t('Presenter') }}
                </th>
                <th class="py-3 px-4 font-semibold text-left">
                  {{ $i18nPresenter.t('Date') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(session, idx) in sessions"
                :key="idx"
                class="border-b last:border-b-0 hover:bg-[#F8F6FD] transition cursor-pointer"
                @click="openSession(session)"
                :class="{
                  'active':
                    (selectedSession && session.presentationId == selectedSession.presentationId) ||
                    (!selectedSession && !idx)
                }"
              >
                <td class="py-3 px-4">
                  {{ $i18nPresenter.t('Session') }} {{ session.index }}
                </td>
                <td class="py-3 px-4">
                  <div class="flex items-center">
                    <aha-avatar
                      :id="session.instructor.id"
                      :name="`${session.instructor.firstName} ${session.instructor.lastName}`"
                      :image="session.instructor.avatar"
                      :width="24"
                      :height="24"
                      class="text-xs mr-1"
                    />
                    {{ session.instructor.firstName }} {{ session.instructor.lastName }}
                  </div>
                </td>
                <td class="py-3 px-4">
                  <aha-formatter
                    :value="session.updatedAt"
                    type="date"
                    :locale="locale"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </aha-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'ReportSessionsModal',
  props: {
    sessions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.presenterLocale,
    }),
    ...mapGetters('multipleSessions', ['selectedSession']),
    titleModal() {
      return `All sessions (${this.sessions.length})`
    },
  },
  created() {
  },
  methods: {
    ...mapActions('multipleSessions', ['setSelectedSession']),

    formatDate(dateStr) {
      const d = new Date(dateStr)
      return d.toLocaleDateString('en-GB') // dd/mm/yyyy
    },
    formatTime(dateStr) {
      const d = new Date(dateStr)
      return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false })
    },
    hideModal() {
      this.$emit('hide')
    },
    openSession(session) {
      this.hideModal()
      this.setSelectedSession(session)
    },
  },
}
</script>

<style lang="scss">
// universal style
.report-session-modal {
  .aha-modal__header {
    background-color: #fff;
    border-bottom: 0;
    position: relative;
    @apply pt-10 md:pt-4;

    .aha-modal__header--text {
      align-items: center;
      @apply mt-0;
    }

    .aha-modal__header--text-content {
      position: relative
    }
  }

  &.backable {
    .aha-modal__header {
      .aha-modal__header--text {
        .aha-modal__header--text-content {
          @apply hidden md:inline-block;
        }
      }
    }
  }

  .aha-modal__content {
    background-color: #fff;
    width: 100%;
    max-width: 37rem;
  }
}
</style>

<style lang="scss" scoped>
.report-session-body {
  @media (min-width: 768px) {
    overflow-y: auto;
  }

  thead {
    tr {
      border-bottom: 1px solid #f0f0f0;
      color: #8A8A8A;
    }
  }

  .table-wrapper {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
  }

  tbody {
    tr {
      border-color: #f0f0f0;
      &:hover {
        background-color: #EBEBEB;
        // font-weight: bold;
      }

      &:last-child {
        border-bottom: none;
      }

      // td {
      //   border-right: 1px solid #EBEBEB;

      //   &:last-child {
      //     border-right: 0;
      //   }
      // }
    }
  }
}

</style>
